
























































import { Component } from 'vue-mixin-decorator';
import RepositoryFactory from '@/repository/RepositoryFactory';
import BaseView from '@/views/BaseView.vue';
import ExamNav from '@/components/ExamNav.vue';
import ExamHeader from '@/components/ExamHeader.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import MarkdownToHTML from '@/common/MarkdownToHTML';

import Faqs from '@/models/faq/Faqs';
import FaqDto from '@/models/faq/Faq';
import * as DesignCode from '@/classification/DesignCode';

@Component(
  {
    components: {
      'e-header': ExamHeader,
      'e-nav': ExamNav,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class Faq extends BaseView {
  private isIndicatorDisplay = false;

  private inquiryUrl = '';

  private created() {
    this.getFaq();
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const FaqCss = document.createElement('link');
    FaqCss.rel = 'stylesheet';
    FaqCss.href = '/css/faq.css';
    this.$el.appendChild(FaqCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });
    // 問い合わせURL取得
    if (this.inquiryUrl === '') {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam().then((response) => {
        if (response.status === 200 && response.data.resources !== undefined) {
          this.bindInquiryUrl(response.data.resources);
        }
      });
    }
  }

  /**
   * リソースから問い合わせURLをセット
   */
  private bindInquiryUrl(resources: any) {
    resources.forEach((resource: any) => {
      if (resource.display_place_key === DesignCode.INQUIRY_URL) {
        this.inquiryUrl = resource.display_text;
      }
    });
  }

  /**
   * エラーメッセージ
   */
  private message = '';

  /**
   * よくあるご質問
   */
  private faqs = new Array<Faqs>();

  /**
   * よくあるご質問取得
   */
  async getFaq() {
    this.isIndicatorDisplay = true;

    this.message = '';
    const FaqRepo = RepositoryFactory.get().faq;
    try {
      await FaqRepo.getFaq().then((response) => {
        if (response.status === 200) {
          let tmpFaqs = new Array<Faqs>();
          tmpFaqs = FaqRepo.convert.deserialize(response.data.faqs, Faqs) as Array<Faqs>;
          tmpFaqs.forEach((category: any) => {
            // 1カテゴリあたりの質問を整形
            const tmpFaqArray = new Array<FaqDto>();
            category.faq.forEach((faq: any) => {
              const tmpFaq = new FaqDto();
              tmpFaq.question = MarkdownToHTML(faq.question);
              tmpFaq.answer = MarkdownToHTML(faq.answer);
              tmpFaq.order = faq.order;
              tmpFaqArray.push(tmpFaq);
            });

            const tmpCategory = new Faqs();
            tmpCategory.categoryTitle = category.categoryTitle;
            tmpCategory.order = category.order;
            tmpCategory.faq = tmpFaqArray;

            this.faqs.push(tmpCategory);
          });
        }
      }).catch((err) => {
        if (err.response && err.response.data.error) {
          this.message = err.response.data.error;
        } else {
          this.message = err.message;
        }
      });
    } catch (_) {
      // do nothing
    } finally {
      this.isIndicatorDisplay = false;
    }

    // 共通jsファイル読込タグ生成
    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }
}
